module.exports = __webpack_public_path__ + "static/media/backsplash4_lowres.d4f070e4.jpg";